<div class="event-header-container">
<div class="event-header" title="Open logged event" (click)="toogleDetails()">
    <span class="event-title">{{getTitle(event)}}</span>
    <span class="arrow-marker" [ngClass]="{'arrow-marker-open': opened,'arrow-marker-closed': !opened}"></span>
</div>
<span class="grouped-events" title="Grouped events" (click)="displayGroup(event.group)"><em>Grouped events</em></span>
<div>
